'use client';

import { useState } from 'react';

import dynamic from 'next/dynamic';
import Image from 'next/legacy/image';

import PetFour from '@/assets/images/HomePageReview_3.webp';
import PetOne from '@/assets/images/pet1.webp';
import PetTwo from '@/assets/images/pet2.webp';
import PetThree from '@/assets/images/pet3.webp';
import RatingStars from '@/components/RatingStars';
import { HeadingThree, HeadingTwo } from '@/components/Typography/Heading';
import Paragraph from '@/components/Typography/Paragraph';
import { Feedback } from '@/types/Home';

const FeedbackCarousel = dynamic(() => import('@/components/Carousel/FeedbackCarousel'));

const feedbacks: Array<Feedback> = [
  {
    id: '1',
    image: PetOne,
    title: 'Game Changer',
    description:
      'My husky has been the pickiest eater his entire life, and often refusing food for days. He LOOOOOOOVES this stuff!!! He actually gets excited to eat now and it makes this momma worry much less! Just some sprinkles on his food and he eats it all and licks his bowl!',
  },
  {
    id: '2',
    image: PetTwo,
    title: 'No Empty Bowl',
    description:
      'The girls were getting tired of eating the same food over and over again. We got the beef and Bison seasoning and they eat everything. They now wait till the seasoning is on or they don’t want to eat! They love it!',
  },
  {
    id: '3',
    image: PetThree,
    title: 'Amazing products',
    description:
      'Capone suffered from red dry skin, shedding and seasonal allergies! Nothing helped, we gave him salmon oil, allergies supplements and spray and his coat is looking so much better!',
  },
  {
    id: '4',
    image: PetFour,
    title: 'For the love of Treats',
    description:
      'Bernie Lomax is a 9 week old Goldendoodle. We have been working on potty training for 8 days and he loves getting a Pawtree treat for going potty outside. Bernie Lomax is very motivated by his Pawtree treats and potty training is going very well',
  },
];

export default function SectionFeedback() {
  const [activeFeedback, setActiveFeedback] = useState<Feedback>(feedbacks[0]);

  const handleChange = (feedback: Feedback) => {
    setActiveFeedback(feedback);
  };

  return (
    <div className="mx-auto sm:pt-[25px] md:mb-[8.75rem] lg:max-w-[67.5rem] lg:pt-[8.5rem]">
      <HeadingTwo
        className="text-center font-circular-std-medium sm:mb-[37px] lg:mb-[25px] lg:leading-[46px]"
        variant="primary"
      >
        From Vets to Pets Hear What People Are Saying!
      </HeadingTwo>
      <div className="flex items-center justify-center sm:flex-col sm:text-center md:flex-row md:text-left">
        <div className="mx-8 sm:mb-[25px] lg:mb-0">
          <Image
            height={169}
            width={169}
            loading="lazy"
            className="rounded-full"
            src={activeFeedback.image}
            alt="review"
          />
        </div>
        <div className="flex max-w-lg flex-1 flex-col justify-center pl-[25px] pr-[15px]">
          <HeadingThree className="mb-2 font-circular-std-medium lg:text-[24px] xxs:text-[24px] " variant="dark">
            {activeFeedback.title}
          </HeadingThree>
          <RatingStars activeStars={5} readonly />
          <Paragraph className="mt-2 min-h-[130px] sm:mx-auto sm:mb-[15px] sm:w-[80%] lg:w-auto" variant="light-gray">
            {activeFeedback.description}
          </Paragraph>
        </div>
        <FeedbackCarousel feedbacks={feedbacks} onChange={handleChange} />
      </div>
    </div>
  );
}
